import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { routes } from 'router/routesConfig';
import { getTranslations } from 'utils/commonFunctions';

const NavBar = ({ hasTeam, isLoggedIn }) => {
  const location = useLocation();
  useEffect(() => {
    const activeTab = document.querySelector('.active');
    activeTab?.scrollIntoView();
  }, [location]);

  const routesArr = Object.values(routes);

  const navBar = (routes) => {
    return routes
      .filter((route) => {
        if (route.id === '3' && !isLoggedIn) return false; // Hide Leaderboard if NOT logged in
        if (route.id === '2' && !hasTeam) return false; // Hide MyPicks if no team
        return !route.hideMenu || (route.teamRequired && hasTeam) || route.id === '3'; // Ensure Leaderboard is shown if logged in
      })
      .map((route, index) => {
        const { id, path, name, transKey } = route;
        return (
          <li key={`nav-${index}`} id={id}>
            <NavLink to={path} activeClassName='active'>
              {getTranslations(transKey, name)}
            </NavLink>
          </li>
        );
      });
  };

  return <ul>{navBar(routesArr)}</ul>;
};

export default NavBar;
